import { useContext } from 'react'
import { GlobalDialogType } from '../../../utils/default/DialogHelper'
import { GlobalDialogContext } from './GlobalDialogProvider'

const useGlobalDialog: () => GlobalDialogType = () => useContext(GlobalDialogContext)

export default useGlobalDialog
